import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import api from "../lib/api";

// iter323 — Print-optimized viewer for training docs. Opened in a new
// tab from Help.jsx → user prints from browser → saves as PDF. No
// server-side conversion pipeline, no heavy dependencies.

const TITLES = {
  admin: "Admin Quick-Start",
  ops: "Ops / Supervisor Quick-Start",
  guard: "Guard / Officer Quick-Start",
  client: "Client Quick-Start",
};

export default function HelpPrint() {
  const { key } = useParams();
  const [markdown, setMarkdown] = useState("");
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/help/docs/${key}`);
        setMarkdown(res.data?.markdown || "");
        // Give React one paint before firing print so the browser has
        // the full DOM measured. `setTimeout(_, 300)` felt right in
        // testing across Chromium / Safari.
        setTimeout(() => window.print(), 300);
      } catch {
        setMarkdown("# Could not load doc\n\nPlease close this tab and try again.");
      }
    })();
  }, [key]);

  return (
    <div data-testid="help-print-page" className="p-10 max-w-3xl mx-auto bg-white text-black print-doc">
      <div className="flex items-center justify-between border-b-2 border-black pb-4 mb-8">
        <div className="font-bold text-2xl tracking-tight">Iris Security · Training</div>
        <div className="text-xs uppercase tracking-widest text-gray-600">
          {TITLES[key] || "Quick-Start"}
        </div>
      </div>
      <ReactMarkdown>{markdown}</ReactMarkdown>
      <style>{`
        .print-doc h1 { font-size: 1.9rem; font-weight: 800; margin-bottom: 0.5rem; }
        .print-doc h2 { font-size: 1.2rem; font-weight: 700; margin-top: 1.5rem; margin-bottom: 0.4rem; border-bottom: 1px solid #ccc; padding-bottom: 0.2rem; }
        .print-doc h3 { font-size: 1rem; font-weight: 700; margin-top: 1rem; }
        .print-doc p, .print-doc li { line-height: 1.55; font-size: 0.95rem; }
        .print-doc ul, .print-doc ol { padding-left: 1.4rem; margin: 0.4rem 0; }
        .print-doc code { font-family: monospace; font-size: 0.85rem; background: #f4f4f5; padding: 0.05rem 0.3rem; border: 1px solid #ddd; }
        .print-doc hr { border: 0; border-top: 1px solid #ccc; margin: 1.5rem 0; }
        .print-doc strong { font-weight: 700; }
        @media print {
          .print-doc { padding: 0.5in; }
          @page { margin: 0.5in; }
        }
      `}</style>
    </div>
  );
}
